import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/common-ui-components/toast/toast.component';
import { CommonModule } from '@angular/common';
import { AppToastService } from './core/services/app-toast.service';
import { AssetsApiService } from './core/http/services/assets.service';
import { initializeDefaultAIModel } from './core/guards/auth.guard';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent, CommonModule],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  toastConfig = {
    isVisible: false,
    message: '',
    bgColor: 'bg-[#FFFBFA]',
    borderColor: 'border-[#FDA29B]',
    iconSrc: 'assets/icons/alert.svg'
  };

  private assetsApiService = inject(AssetsApiService);

  constructor(private appToastService: AppToastService) {}

  ngOnInit() {
    this.appToastService.toast$.subscribe(config => {
      this.toastConfig = {
        isVisible: config.isVisible,
        message: config.message,
        bgColor: config.bgColor || 'bg-[#FFFBFA]',
        borderColor: config.borderColor || 'border-[#FDA29B]', 
        iconSrc: config.iconSrc || 'assets/icons/alert.svg'
      };
    });

    // Initialize default AI model if not set
    this.initializeDefaultAIModel();
  }

  private initializeDefaultAIModel(): void {
    // Use the shared initialization function
    initializeDefaultAIModel(this.assetsApiService);
  }
}
